import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

@Component({
    selector: 'app-input-button',
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
    templateUrl: './input-button.component.html',
    styleUrl: './input-button.component.scss'
})
export class FormlyInputButtonComponent extends FieldType<
  FieldTypeConfig<FormlyFieldProps & { onButtonClick: () => void; buttonLabel: string }>
> {}
